import {Map} from 'immutable';
import {PRODUCTION} from 'utils/env';
import {camelCast, isArrayOfStrings} from 'requests/utils';
import * as actionTypes from '../actionTypes';
import {retrieved, deleted, created, noContent, jobStatusTopic} from './updaters';

export const QUEUED = '--queued--';
export const UNKNOWN = '--unknown--';
export const OK_BUT_MISUNDERSTOOD = '--ok-but-misunderstood--';

export function requests(state = null, action) {
  let nextState = state || Map({
    representations: Map({}),
    resources: Map({}),
    jobs: Map({}),
    cache: Map({}),
    status: Map({}),
    errors: Map({}),
  });

  if (action.request) {
    nextState = nextState
      .setIn(['cache', action.request.uuid], action.request);
  }

  if (action.type === actionTypes.REQUEST_QUEUED) {
    nextState = nextState
      .setIn(['status', action.request.uuid], QUEUED);
  }

  if (action.type === actionTypes.RESPONSE_UNHANDLED_STATUS_CODE) {
    if (!PRODUCTION) {
      /* eslint-disable no-console */
      console.error('Unhandled status code for requests action');
      console.log(action);
      /* eslint-enable no-console */
    }

    nextState = nextState
      .setIn(['status', action.request.uuid], UNKNOWN);
  }

  if (action.type === actionTypes.RESPONSE_NOT_JSON) {
    nextState = nextState
      .setIn(['status', action.request.uuid], OK_BUT_MISUNDERSTOOD);
  }

  if (~[actionTypes.RESPONSE_DATA, actionTypes.RESPONSE_CREATED].indexOf(action.type)) {
    nextState = retrieved(nextState, action);
  }

  if (action.type === actionTypes.RESPONSE_CREATED) {
    nextState = created(nextState, action);
  }

  if (action.type === actionTypes.RESPONSE_DELETED) {
    nextState = deleted(nextState, action);
  }

  if (~[actionTypes.RESPONSE_DATA, actionTypes.RESPONSE_CREATED].indexOf(action.type)) {
    nextState = jobStatusTopic(nextState, action);
  }

  if (action.type === actionTypes.RESPONSE_NO_CONTENT) {
    nextState = noContent(nextState, action);
  }

  if (~[actionTypes.RESPONSE_NOT_FOUND, actionTypes.RESPONSE_NOT_ALLOWED].indexOf(action.type)) {
    nextState = nextState
      .setIn(['status', action.request.uuid], action.response.status);
  }

  if (action.type === actionTypes.RESPONSE_BAD_REQUEST) {
    const nextErrors = Map(camelCast(action.errors)).map((error) => {
      return (isArrayOfStrings(error)) ? error.join(', ') : error;
    });
    nextState = nextState
      .setIn(['status', action.request.uuid], action.response.status)
      .setIn(['errors', action.request.uuid], nextErrors);
  }

  if (action.type === actionTypes.RESPONSE_FAILURE) {
    nextState = nextState
      .setIn(['status', action.request.uuid], action.response.status);
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/requests/reducers/index.js